import axios from "axios";
import { getUnitApiBaseFour, SUB_URL_KCA } from "../BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const KCA_Service = {
  getKCA_DailyReport: async (formData) => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL_KCA.get_kca_daily_report}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("KCA Daily Report Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching KCA Daily Report:", error);
      return {
        status: false,
        message: "Failed to fetch daily report",
        data: [],
      };
    }
  },
};

export default KCA_Service;